module.exports = __webpack_public_path__ + "img/img-event-tab-05.17b8b797.png";